import { render, staticRenderFns } from "./editroDialog.vue?vue&type=template&id=95262ba6&scoped=true&"
import script from "./editroDialog.vue?vue&type=script&lang=js&"
export * from "./editroDialog.vue?vue&type=script&lang=js&"
import style0 from "./editroDialog.vue?vue&type=style&index=0&id=95262ba6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95262ba6",
  null
  
)

export default component.exports